import notificationTemplate from '../../../templates/common/notificationTemplate.html';

const UserAlertView = Backbone.View.extend({
  id: 'user-alert-notification-block',
  className: 'notification-bar',

  initialize() {

  },

  render(text) {
    let notification;

    if (text && text.length > 0) {
      notification = _.template(notificationTemplate, { notification: text, type: 'warning' });

      this.$el.appendTo(document.body);
      this.$el.html(notification);

      this.$('#user-alert-close').on('click', (e) => {
        this.close(e);
      });
    }
  },

  close() {
    this.$el.hide();
  },

});

export default UserAlertView;
